import { Exception } from './Exception';
export class APIv4Exception extends Exception {
  constructor(code, message, stack) {
    super(`Bad Request for API v4: (${code}) ${message}`, stack);
    this.name = 'APIv4Exception';
  }
}
